import context from '../../config/context'
import React from 'react'
import { string, func, shape, bool } from 'prop-types'
import { Form } from '@cobalt/cobalt-react-components'
import PasswordPolicies from '../PasswordPolicies'
import {
  PASSWORD,
  PASSWORD_CONFIRMATION,
  DIFFERENT_PASSWORDS_ERROR_MESSAGE
} from '../../constants/ui.labels'
import PasswordInputFieldGroup from '../PasswordInputFieldGroup'

const VALIDATION_DELAY = 500

class PasswordChangeFieldGroup extends React.Component {
  constructor(props) {
    super(props)
    this.state = { timeout: null }
  }

  hasMatchingPasswords = (password, passwordConfirmation) =>
    password === passwordConfirmation

  hasBothPasswordsPresent = (password, passwordConfirmation) =>
    Boolean(password && passwordConfirmation)

  evaluatePasswordDiff = (password, passwordConfirmation) => {
    const hasBothPasswordsPresent = this.hasBothPasswordsPresent(
      password,
      passwordConfirmation
    )
    const hasMatchingPasswords = this.hasMatchingPasswords(
      password,
      passwordConfirmation
    )

    const isValid = hasBothPasswordsPresent && hasMatchingPasswords

    const error =
      !hasBothPasswordsPresent || hasMatchingPasswords
        ? null
        : DIFFERENT_PASSWORDS_ERROR_MESSAGE

    return { isValid, error }
  }

  updateFormData = (password, passwordConfirmation) => {
    const { formData, onFormChange } = this.props

    const { isValid, error } = this.evaluatePasswordDiff(
      password,
      passwordConfirmation
    )

    onFormChange({
      ...formData,
      password,
      passwordConfirmation,
      isValid
    })

    const validator = () =>
      this.props.onFormChange({ ...this.props.formData, error })

    clearTimeout(this.state.timeout)
    this.setState({ timeout: setTimeout(validator, VALIDATION_DELAY) })
  }

  handlePasswordChange = event => {
    const { formData } = this.props
    const password = event.target.value

    this.updateFormData(password, formData.passwordConfirmation)
  }

  handlePasswordConfirmationChange = event => {
    const { formData } = this.props
    const passwordConfirmation = event.target.value

    this.updateFormData(formData.password, passwordConfirmation)
  }

  handleOnFocus = () => this.setState({ focus: true })

  handleOnBlur = () => this.setState({ focus: false })

  render() {
    const { formData, disabledForm } = this.props
    const { password, passwordConfirmation } = formData

    return (
      <React.Fragment>
        <PasswordInputFieldGroup
          label={PASSWORD}
          disabledForm={disabledForm}
          placeholder={PASSWORD}
          password={password}
          onPasswordChange={this.handlePasswordChange}
          onFocus={this.handleOnFocus}
          onBlur={this.handleOnBlur}
        />
        {this.state.focus ? (
          <Form.Field>
            <PasswordPolicies passwordPolicies={context.passwordPolicies} />
          </Form.Field>
        ) : null}
        <PasswordInputFieldGroup
          label={PASSWORD_CONFIRMATION}
          disabledForm={disabledForm}
          placeholder={PASSWORD_CONFIRMATION}
          password={passwordConfirmation}
          onPasswordChange={this.handlePasswordConfirmationChange}
        />
      </React.Fragment>
    )
  }
}

PasswordChangeFieldGroup.propTypes = {
  formData: shape({
    password: string,
    passwordConfirmation: string
  }).isRequired,
  onFormChange: func.isRequired,
  disabledForm: bool.isRequired
}

PasswordChangeFieldGroup.defaultProps = {
  disabledForm: false
}

PasswordChangeFieldGroup.VALIDATION_DELAY = VALIDATION_DELAY

export default PasswordChangeFieldGroup
